import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question9.css";
import Man from "./images/man.jpg";
import Woman from "./images/woman.jpg";

const Question9 = ({ onAnswer, userResponse }) => {
  const [animateOut, setAnimateOut] = useState(false);

  const question = {
    title: "Would you rather:",
    options: [
      {
        label: "Struggle & Complete Your Research The Traditional Way",
        image: Man,
      },
      {
        label:
          "Invest in Something That Accelerates Your Research & Helps You Finish Stronger, Faster, & Smarter",
        image: Woman,
      },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }
    setAnimateOut(true);
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question9-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        <motion.h2
          className="question9-head"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5 }}
        >
          {question.title}
        </motion.h2>

        <div className="option9-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index}
              className={`radio9-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`}
              htmlFor={`option-${index}`}
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100vw" }}
              transition={{
                duration: 0.5,
                delay: 0.5 + index * 0.2,
              }}
            >
              <input
                type="radio"
                id={`option-${index}`}
                name={`question-${question.title}`}
                value={option.label}
                checked={userResponse[question.title] === option.label}
                onChange={() => onAnswer(question.title, option.label)}
              />
              <motion.img
                className="option9-img"
                src={option.image}
                alt={option.label}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.8 }}
              />
              <span className="radio9-label">{option.label}</span>{" "}
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          className="next-button"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question9;
